<template>
  <div class="wrapper">
    <section id="login">
      <div class="container-fluid">
        <div class="row full-height-vh">
          <div class="col-12 d-flex align-items-center justify-content-center gradient-aqua-marine">
            <div class="card px-4 py-2 box-shadow-2 width-600">
              <div class="card-header text-center">
                <h3>{{ $t("labels.login") }}</h3>
              </div>
              <div class="card-body">
                <div class="card-block">
                  <form @submit.prevent="login">
                    <div class="form-group">
                      <div class="col-md-12">
                        <input
                          type="email"
                          class="form-control form-control-lg"
                          name="inputEmail"
                          id="inputEmail"
                          v-model="username"
                          :placeholder='$t("labels.email")'
                          required
                          email
                        >
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="col-md-12">
                        <input
                          type="password"
                          class="form-control form-control-lg"
                          name="inputPass"
                          id="inputPass"
                          v-model="password"
                          :placeholder='$t("labels.password")'
                          required
                        >
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="text-center col-md-12">
                        <button
                          type="submit"
                          class="btn btn-success px-4 py-2 text-uppercase white font-small-4 box-shadow-2 border-0"
                        >{{ $t("labels.submit") }}</button>
                      </div>
                    </div>
                  </form>
                  <ul class="links">
                    <li>
                      <router-link :to="{ name: 'forgot', query: {l: currentLocale }}">{{ $t("labels.forgotPassword") }}</router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'resendActivation', query: {l: currentLocale }}">{{ $t("labels.noConfirmation") }}</router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'register', query: {l: currentLocale }}">{{ $t("labels.register") }}</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import AuthService from "../../services/auth";

export default {
  name: "LoginPage",
  metaInfo: {
    title: "Dravet Diary Admin", // set a title
    titleTemplate: "%s" // title is now "My Example App - Yay!",
  },
  props: {
    currentLocale: {
      type: String,
      default: 'it'
    }
  },
  data: function() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    login: async function() {
      await AuthService.login(this.username, this.password);
      this.$router.push({ name: "home"})
    }
  }
};
</script>



